import {SIGN_IN_ERROR,OTC_ERROR,ACTIVATION_ERROR,PASSWORD_UPDATE}from'./index.js';var errorsJson = {
  D_107: {
    component: 'global',
    errorType: 'L3',
    description: 'Unsuccessful login attempt, ex. username and/or Password is incorrect or fails to authenticate',
    eventType: SIGN_IN_ERROR,
    title: 'errors.D_107.title',
    message: 'errors.D_107.message'
  },
  E_116: {
    component: 'otp-code',
    errorType: 'field',
    eventType: OTC_ERROR,
    description: 'Invalid OTP entry',
    title: '',
    message: 'errors.E_116.message'
  },
  G_200: {
    component: 'global',
    errorType: 'L3',
    eventType: OTC_ERROR,
    description: 'General unknown and unanticipated error.',
    title: 'errors.generic.title',
    message: 'errors.generic.message'
  },
  G_201: {
    component: 'global',
    errorType: 'L3',
    eventType: ACTIVATION_ERROR,
    description: 'Error in activation auth tree',
    title: 'errors.generic.title',
    message: 'errors.generic.message'
  },
  G_202: {
    component: 'global',
    errorType: 'L3',
    eventType: OTC_ERROR,
    description: 'Error in adding mobile number',
    title: 'errors.generic.title',
    message: 'errors.generic.message'
  },
  D_504: {
    component: 'username',
    errorType: 'field',
    description: 'Username already exists in Identity Provider/IAM',
    message: 'errors.D_504.message'
  },
  D_505: {
    component: 'global',
    errorType: 'L3',
    eventType: SIGN_IN_ERROR,
    description: 'Error while getting user profile from IAM.',
    title: 'errors.generic.title',
    message: 'errors.generic.message'
  },
  D_506: {
    component: 'username',
    errorType: 'field',
    description: 'Generic error when username is invalid',
    message: 'errors.D_506.message'
  },
  D_601: {
    component: 'global',
    errorType: 'L3',
    eventType: PASSWORD_UPDATE,
    description: 'System failed to update password',
    title: '',
    message: 'errors.D_601.message'
  },
  D_603: {
    component: 'global',
    errorType: 'L3',
    eventType: SIGN_IN_ERROR,
    description: 'Account Locked for Signin',
    title: '',
    message: 'errors.D_603.message'
  },
  D_606: {
    component: 'password',
    errorType: 'field',
    description: 'used old password',
    title: '',
    message: 'errors.D_606.message'
  },
  D_610: {
    component: 'otp-code',
    errorType: 'field',
    eventType: OTC_ERROR,
    description: 'OTP has expired',
    title: '',
    message: 'errors.D_610.message'
  },
  D_611: {
    component: 'password',
    errorType: 'field',
    description: 'New password does not meet strength requirements.',
    title: '',
    message: 'errors.D_611.message'
  },
  D_613: {
    component: 'password',
    errorType: 'field',
    eventType: PASSWORD_UPDATE,
    description: 'Weak password.',
    title: '',
    message: 'errors.D_613.message'
  },
  D_614: {
    component: 'MFA',
    errorType: 'L3',
    eventType: OTC_ERROR,
    description: 'OTP locked after 3 times',
    title: 'errors.D_614.title',
    message: 'errors.D_614.message'
  },
  D_615: {
    component: 'global',
    errorType: 'L2',
    eventType: OTC_ERROR,
    description: 'OTP locked after 3 times',
    title: 'errors.D_615.title',
    message: 'errors.D_615.message'
  },
  D_617: {
    component: 'global',
    errorType: 'L3',
    eventType: PASSWORD_UPDATE,
    description: 'Current password incorrect in verify password',
    title: '',
    message: 'errors.D_617.message'
  },
  D_619: {
    component: 'global',
    errorType: 'L3',
    description: 'DOB or lastname not found',
    title: '',
    message: 'errors.D_619.message'
  },
  D_620: {
    component: 'password',
    errorType: 'field',
    description: 'Special combination used in password',
    title: '',
    message: 'errors.D_620.message'
  },
  D_622: {
    component: 'global',
    errorType: 'L2',
    eventType: OTC_ERROR,
    description: 'OTP retried 2 times',
    title: 'errors.D_622.title',
    message: 'errors.D_622.message'
  },
  D_623: {
    component: 'global',
    errorType: 'L2',
    description: 'Manage Id - OTP error after 3 times',
    title: 'errors.D_623.title',
    message: 'errors.D_623.message'
  },
  D_624: {
    component: 'global',
    errorType: 'L2',
    description: 'Manage Id - OTP retried 2 times',
    title: 'errors.D_624.title',
    message: 'errors.D_624.message'
  },
  D_633: {
    component: 'global',
    errorType: 'L2',
    description: 'Third failed password verification',
    title: '',
    message: 'errors.D_633.message'
  },
  D_634: {
    component: 'global',
    errorType: 'L2',
    eventType: ACTIVATION_ERROR,
    description: 'Alternate email activation credentials error',
    title: '',
    message: 'errors.D_634.message'
  },
  D_635: {
    component: 'global',
    errorType: 'L2',
    eventType: ACTIVATION_ERROR,
    description: 'Alternate email activation error',
    title: '',
    message: 'errors.D_635.message'
  },
  D_636: {
    component: 'global',
    errorType: 'L2',
    eventType: ACTIVATION_ERROR,
    description: 'Alternate email activation out of attempts',
    title: 'errors.D_636.title',
    message: 'errors.D_636.message'
  },
  D_700: {
    component: 'global',
    errorType: 'L2',
    eventType: PASSWORD_UPDATE,
    description: 'Password reset limit reached',
    title: '',
    message: 'errors.D_700.message'
  },
  D_507: {
    component: 'username',
    errorType: 'field',
    description: 'Generic error when username is invalid',
    message: 'forgotPassword.error.username'
  }
};export{errorsJson as default};